import React from 'react';
import { ChangePasswordForm, FormLayout } from '../../containers';
import { ConsentDecorator } from '../../components/RoutesDecorator/ConsentDecorator';

const ChangePasswordPage: React.FC = () => {
    return (
        <ConsentDecorator>
            <FormLayout>
                <ChangePasswordForm />
            </FormLayout>
        </ConsentDecorator>
    );
};

export default ChangePasswordPage;
